import Image1 from "../../assets/leetcode.png";
import Image2 from "../../assets/codechef.jpg";
import Image3 from "../../assets/codeforces.png";

export const Data = [
  {
    id: 1,
    image: Image1,
    title: "LeetCode",
    Plink: "https://leetcode.com/jeetsavsani1173/",
  },
  {
    id: 2,
    image: Image2,
    title: "CodeChef",
    Plink: "https://www.codechef.com/users/jeetsavsani117",
  },
  {
    id: 3,
    image: Image3,
    title: "Codeforces",
    Plink: "https://codeforces.com/profile/jeetsavsani117",
  },
];
